import { FC } from 'react';
import { TApiError } from '@mybonum/api';
import { CustomModal } from '@mybonum/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Flex, Typography } from 'antd';

import { TInviteAllModalProps } from './types.ts';

import { useMessage } from '@/hooks/use-message.ts';
import { API } from '@/services/api';

export const InviteAllModal: FC<TInviteAllModalProps> = ({ open, onClose }) => {
    const queryClient = useQueryClient();
    const { message } = useMessage();

    const { mutateAsync: inviteAll, isPending } = useMutation({
        mutationFn: API.PRACTICES.inviteAll,
    });

    const handleSend = async (): Promise<void> => {
        try {
            const data = await inviteAll();
            await queryClient.invalidateQueries({
                queryKey: API.PRACTICES.getPractices({}).queryKey,
            });
            onClose();
            if ('error' in data) {
                message.error(data.error);
            } else {
                message.success(data.message);
            }
        } catch (error) {
            const apiError = error as TApiError;
            const responseData = apiError.response?.data;
            const errorMessage =
                responseData?.error || apiError.message || 'Something went wrong...';
            await message.error(errorMessage);
        }
    };

    return (
        <CustomModal
            width={360}
            open={open}
            padding="small"
            onCancel={onClose}
            title="Invitation Emails"
            destroyOnHidden
            footer={
                <Flex gap={16} justify="space-between">
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" onClick={handleSend} loading={isPending}>
                        Send
                    </Button>
                </Flex>
            }
        >
            <Typography style={{ color: 'var(--color-brand-info)', textAlign: 'center' }}>
                Are you sure you want to send the Introduction / Invitation Emails to all clinics?
            </Typography>
        </CustomModal>
    );
};
